import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import "../../Patient/list.scss"
import RoomType from "./roomType"

const RoomTypeContainer = () => {


  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
        <RoomType  />
        </>
      </div>
    </div>
  )
}

export default RoomTypeContainer